import axios from "axios";
import { Toast } from "vant";
import Vue from "vue";
Vue.use(Toast);

const http = axios.create({
  baseURL: "https://www.trusthongkong.com",
});
export default http;
